import { callApi } from "../api";

export const fetchGetBankSuggestions = (text) =>
  callApi(`entities/custodianEntities?text=${text}`, null, "GET");

export const fetchGetCountrySuggestions = (text) => callApi(`entities/countries?search=${text}`, null, "GET");

export const setRedirectionData = (body) => callApi("redirection/set", body, "POST");

export const getRedirectionData = (body) => callApi("redirection/get", body, "POST");

export const fetchCorexBuildVersion = () => {
  return callApi("corexBuildVersion", null, "GET");
};

export const fetchApiBuildVersion = () => {
  return callApi("apiBuildVersion", null, "GET");
};

export const fetchTooltipsAndNotes = () => {
  return callApi("tooltips", null, "GET");
};

export const getAssetAttachment = (body) => callApi("assetAttachment", body, "POST");
